import script from "./StepItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepItem.vue?vue&type=script&setup=true&lang=ts"

import "./StepItem.vue?vue&type=style&index=0&id=266c8bdc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-266c8bdc"]])

export default __exports__